module.exports = __webpack_public_path__ + "static/media/Arrow-left.501322c6.svg";